var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert-graph"},[_c('div',{staticClass:"background"}),_c('div',{staticClass:"value-area",style:(("width: " + _vm.width + "px; background-color: " + _vm.color))})])}
var staticRenderFns = []

export { render, staticRenderFns }